export class TipologiaSoggettoResponsabile{
    id:number;
    descrizione:string; 
    sottoTipologia: string;   
}